import { configureStore } from '@reduxjs/toolkit';
import messageReducer from '@/messages/messageSlice';
import chatReducer from '@/chats/chatSlice';
import userReducer from '@/user/userSlice';
import adminReducer from '@/admin/adminSlice';
import { type TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

export const store = configureStore({
  reducer: {
    messages: messageReducer,
    chats: chatReducer,
    user: userReducer,
    admin: adminReducer
  },
});

export type RootState = ReturnType<typeof store.getState>;
type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
